"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.constructorReducer = constructorReducer;

var _dotPropImmutable = require("dot-prop-immutable");

var _actions = require("./actions");

function constructorReducer(state, action) {
  var type = action.type,
      payload = action.payload;

  switch (type) {
    case _actions.INIT:
      return payload;

    case _actions.CHANGE_COPY_DISABLED:
      return (0, _dotPropImmutable.merge)(state, 'disabledCopy', payload);

    default:
      return state;
  }
}